// formData 转 json
export function parser (path, notransf) {
  if (typeof path === 'undefined') {
    console.warn('期望的url值不存在！')
    return
  }
  path = notransf ? path : path.toLowerCase()
  let params = null
  if (path.indexOf('?') > -1) {
    params = path.split('?')[1]
  } else {
    params = path
  }

  let hash = ''
  let aParams = null
  if (params.indexOf('#/') > -1) {
    hash = params.split('#/')[1]
    aParams = params.split('#/')[0] ? (aParams = params.split('#/')[0].split('&')) : []
  } else {
    aParams = params ? params.split('&') : []
  }
  let oParams = {}
  hash && (oParams.hash = hash)
  for (let i = 0; i < aParams.length; i++) {
    let keyVal = aParams[i].split('=')
    oParams[keyVal[0]] = keyVal[1]
  }
  return oParams
}

// 验证是否是链接
export function verifLink (str) {
  const reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/
  return reg.test(str)
}

// 验证数字
export function verifNumber (str) {
  if (isNaN(Number(str))) {
    return false
  }
  return true
}

// 验证小数
export function verifFloat (str) {
  return str.indexOf('.') > -1
}

// 补零
export function toDou (iNum) {
  return iNum > 9 ? iNum : '0' + iNum
}

// 转换/Date(xxxxxx)/为时间
export function transferDate (str) {
  if (/^\/Date\(/.test(str)) {
    return new Date(parseInt(str.slice(6)))
  }
  return str
}

// 数组去重
export function delRepeat (arr) {
  let result = []
  for (let i = 0; i < arr.length; i++) {
    let item = arr[i]
    if (result.indexOf(item) === -1) {
      result.push(item)
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/common/js/util.js